import { CardTagsProps } from "@/types";
import cn, { join } from "@/utils/cn";

export default function CardTags({ tags, className }: CardTagsProps) {
  const isHiglighted = "bg-gold-20 text-black";

  return (
    <div className={cn("absolute top-s left-s flex flex-wrap gap-xs md:static", className)}>
      {tags.map((tag, index) => (
        <span
          key={`tag-${index}`}
          className={join(
            `inline-block w-fit box-material-primary  backdrop-blur-xl rounded font-normal uppercase py-3xs p-[6px] text-s  before:rounded`,
            tag.isHiglighted ? isHiglighted : "text-white",
          )}
        >
          {tag.label}
        </span>
      ))}
    </div>
  );
}
